import { ADMIN_NOTES_LIST } from './index';
import { Action } from '../action';
import { ServiceInfo } from '@shared/core';

export class AdminNotesListInitAction implements Action {
	readonly type = ADMIN_NOTES_LIST.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminNotesListDestroyAction implements Action {
	readonly type = ADMIN_NOTES_LIST.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminNotesListClickEditAction implements Action {
	readonly type = ADMIN_NOTES_LIST.CLICK_EDIT;
	constructor(
		public payload?: any,
		public correlationId?: number
	) {}
}

export class AdminNotesListSelectAction implements Action {
	readonly type = ADMIN_NOTES_LIST.SELECT;
	constructor(
		public payload: ServiceInfo,
		public correlationId?: number
	) {}
}

export class AdminNotesListSelectParkAction implements Action {
	readonly type = ADMIN_NOTES_LIST.SELECT_PARK;
	constructor(
		public payload: number,
		public correlationId?: number
	) {}
}

export class AdminNotesListClickOrganizationBacklinkAction implements Action {
	readonly type = ADMIN_NOTES_LIST.CLICK_ORGANIZATION_BACKLINK;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class AdminNotesListClickGroupBacklinkAction implements Action {
	readonly type = ADMIN_NOTES_LIST.CLICK_GROUP_BACKLINK;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}
